export const SAVE_BUTTON_CLICK = 'LabelReviewValidationForm/SAVE_BUTTON_CLICK';
